import './JiraCredentialsEditButton.scss';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { EditOutlined } from '@ant-design/icons';
import { JiraCredentialsUpdate } from './JiraCredentialsUpdate';
import React from 'react';
import { useBoolean } from '@hooks';
import { Button, Popover } from 'antd';
export const JiraCredentialsEditButton = ({ form }) => {
    const [editing, handleSetEditing] = useBoolean(false);
    return (React.createElement(Popover, { content: React.createElement(JiraCredentialsUpdate, { form: form, onClose: handleSetEditing.off }), onOpenChange: handleSetEditing.toggle, open: editing, overlayClassName: 'jira-credentials-edit', placement: 'bottomLeft', trigger: 'click' },
        React.createElement(Button, { icon: React.createElement(EditOutlined, null), type: 'link' }, COPY_SPECIFIC.EDIT_SETTINGS)));
};
